import type { FaireProductEntity } from "../../entity_types/product";

export const p_quhrj44ew5: FaireProductEntity = {
  token: "p_quhrj44ew5",
  type: "product",
  name: "Flow Alkaline Flavored Spring Water, 16.9oz",
  brandToken: "b_47s98587ya",
  brandName: "Oasis Snacks",
  imageUrl:
    "https://cdn.faire.com/fastly/23a4235b70b8504d2dd5244edf6e9056ae21725bd0137171b89afeaec9de04c0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1916349cd784ef7744823db6600c35f4b9f7b954ce35be9324071b5a71fb04b.png",
    "https://cdn.faire.com/fastly/051734392a727a764ee2b76d20657a9daed28243bcca5f5c723e0256a950cf57.png",
    "https://cdn.faire.com/fastly/2a07d8f56ca23292debfc1a36b02c8bbff6df067a021986c534ecc74dc4e932f.png",
    "https://cdn.faire.com/fastly/d621427f1c90bd6d29ad408bc99d8fb77f0b280cb197befc6c2d1c4194f4dac2.png",
    "https://cdn.faire.com/fastly/405bdea6618a728dfdc175070ddfba0377a81977fe2c16d0b0fa6c6d2c6b848e.png",
    "https://cdn.faire.com/fastly/6b6eb0f1c02f3fd9527f438ee6bff7d8c2a26171e59db75aa319b5c87cc33180.png",
    "https://cdn.faire.com/fastly/4f19f1bbbb73d859f6c49a2d1c5e5bb446e78181a062f8f28bf5f7cf67057eee.png",
    "https://cdn.faire.com/fastly/1ab29127fbb3caa28f9e3dcde0666d28747d5ff415e90d4f694e1c8b7b3d9076.png",
  ],
  priceDollars: 2.42,
  description:
    "Flow Flavored Spring Water brings delicious organic flavors to our naturally alkaline spring water. With zero sugar, zero calories, zero juice and zero sweeteners, the flavors have a subtle, refreshing taste that will help you hydrate all day long.",
  tags: [],
  msrpDollars: 4.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:17.497Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
